import { baseUrl } from "api/constants";
import axios from "axios";

export const APIS = {
    requestSubscribe : "/newsletter/requestSubscription",
    confirmSubscribe : "/newsletter/confirmSubscription",
    checkSubscriptionStatus : "/newsletter/subscriptionStatus",
    unsubscribe : "/newsletter/unsubscribe"
}



export const requestSubscription = (email) => {

    return new Promise(async (resolve , reject) => {
        try {
            const url = baseUrl + APIS['requestSubscribe'];
            const res = await axios.post(url, { email });
            resolve({
                success : true,
                data : res?.data
            })
           
        } catch (err) {
            console.error("Subscription error:", err?.response);
            reject({
                success : false,
                data : (err?.response && err?.response && err?.response?.data && err?.response?.data?.message) ? err?.response?.data?.message : err?.message
            })
        
    }
   
    })}

export const confirmSubscription = (token) => {

    return new Promise(async (resolve , reject) => {
        try {
            const url = baseUrl + APIS['confirmSubscribe'];
            const res = await axios.post(url, { token });

            if(res && res?.data && res?.data?.status){
                resolve({
                    success : true,
                    data : res?.data
                })
            }
            else{
                reject({
                    success : false,
                    data : "Something went wrong"
                })
            }
            
            
        } catch (err) {
            console.error("Confirm Subscription error:", err);
            reject({
                success : false,
                data : err?.message ? err?.message : "Something went wrong"
            })
        
    }
    
    })}

export const unSubscribe = (email , reasonString = '') => {

        return new Promise(async (resolve , reject) => {
            try {
                const url = baseUrl + APIS['unsubscribe'];
                const res = await axios.post(url, { email , unsubscribeReason : reasonString });
    
                if(res && res?.data && res?.data?.status){
                    resolve({
                        success : true,
                        data : res?.data
                    })
                }
                else{
                    reject({
                        success : false,
                        data : "Something went wrong"
                    })
                }
                
                
            } catch (err) {
                console.error("Unsubscribe error:", err);
                reject({
                    success : false,
                    data : err?.message ? err?.message : "Something went wrong"
                })
            
        }
        
    })}

export const showPopupOrNot = () => {
    //show popup only when user or guest has not subscribed yet
    const subscribed = localStorage.getItem('subscribed')

    if(subscribed){

        //user have subscribed so will not show the popup
        return false
    }
    else{
        const lastShowedSubscribe = localStorage.getItem('lastShowedSubscribe')

        if(lastShowedSubscribe){
            const diff = getDaysDifference(lastShowedSubscribe, Date.now())
            console.log(diff , ' difference in seconds');
            
            if(diff > 3){
                //last popup is being showed 3 days before
                return true
            }
            else{
                //last popup is being within last 3 days
                return false
            }
        }
        //popop is being showed for the first time
        else{
            return true
        }

    }
}

function getDaysDifference(startTimestamp, endTimestamp) {
    const msInDay = 1000 * 60 * 60 * 24;
    const diffMs = endTimestamp - startTimestamp;
    return Math.floor(diffMs / msInDay);
  }
  

  function getSecondsDifference(startTimestampMs, endTimestampMs) {
    return Math.floor((endTimestampMs - startTimestampMs) / 1000);
  }
  
